import { useState, useEffect } from 'react';

import { UserReadFields } from '@ragu-components/ord-types';
import { EmailField, TextField } from 'react-admin';

import { flowchartLogger } from '../../../../lib/logger';
import ResourceList from '../../components/ResourceList';
import NodeControlForm from '../NodeControlForm';

import type { NodeControlsProps } from '../../dataProvider/types';
import type { UserRead } from '@ragu-components/ord-types';

export interface LCRType extends Record<string, unknown> {
  user: UserRead | null;
}

interface LCRControlsProps extends NodeControlsProps {
  updateNodeData: (data: Record<string, unknown>) => void;
  data: LCRType;
}

export default function LCRControls({ updateNodeData, data }: LCRControlsProps): React.ReactElement {
  const [user, setUser] = useState<UserRead | null>(data.user ?? null);

  const onLcrDataUpdate = (event: React.FormEvent): void => {
    event.preventDefault();
    flowchartLogger.debug('LCRControls: onLcrDataUpdate', { user });
    if (user === undefined || user === null) {
      flowchartLogger.debug('LCRControls: userId is undefined or empty. Update cancelled.');
      return;
    }
    updateNodeData({ user });
  };

  useEffect(() => {
    flowchartLogger.debug('LCRControls: user changed', { user });
    updateNodeData({ user });
  }, [user, updateNodeData]);

  return (
    <NodeControlForm
      onSubmit={onLcrDataUpdate}
      isDisabled={user === undefined || user === null}
      data={data}
      updateNodeData={updateNodeData}
    >
      <ResourceList
        resource='users'
        selectedResourceId={user !== null ? user.id : null}
        onRowClick={(_id, _resource, record) => {
          setUser(record as UserRead);
          return false;
        }}
      >
        <TextField source={UserReadFields.username} />
        <TextField source={UserReadFields.firstname} />
        <TextField source={UserReadFields.lastname} />
        <EmailField source={UserReadFields.email} />
      </ResourceList>
    </NodeControlForm>
  );
}
